/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { collectionReducer } from './collection.reducer';
import { homePageReducer } from './home.page.reducer';
import {pcsLogsReducer} from './pcs.logs.reducer';
import {enableAccessCodeSendToPCSReducer} from './access.code.pcs.reducer';
import {accessCodeReducer} from "./access.code.reducer";
import {compCodeReducer} from "./comp.code.reducer";
import {bookdetailsreducer} from "./bookdetails.reducer";
import i18nReducer from './i18n.reducer';
import {orderDetailReducer} from "./order.details.reducer";
import {collectionNotesReducer} from "./collection.notes.reducer";
import {pdfLinksReducer} from "./pdf.links.reducer";
import {messageReducer} from  "./message.reducer";
import {modalReducer} from  "./modal.reducer";
import {coverReducer} from "./cover.reducer";
import {alertReducer} from "./alert.reducer";
import {etextStatusReducer} from "./etext.status.reducer";
import {productDetailsReducer} from "./product.details.reducer";
import {offerDetailsReducer} from "./offer.details.reducer";
import {vitalsourceStatusReducer} from "./vitalsource.status.reducer";
import {bookBuildReducer} from "./book.build.reducer";
import {resourceSearchReducer} from "./resource.search.reducer";
import {uploadReducer} from "./resource.upload.reducer";
import {courseDetailsReducer} from "./coursedetails.reducer";

const rootReducer = combineReducers({
    activeCollection: collectionReducer,
    bookBuildContent: bookBuildReducer,
    bookdetailsreducer : bookdetailsreducer,
    collectionNotesReducer :collectionNotesReducer,
    frontCover: coverReducer,
    pcsLogs: pcsLogsReducer,
    accessCodeSendToPcs: enableAccessCodeSendToPCSReducer,
    homePage: homePageReducer,
    accessCodeSetup: accessCodeReducer,
    orderDetails : orderDetailReducer,
    router: routerReducer,
    i18n: i18nReducer,
    pdfLinks: pdfLinksReducer,
    messages: messageReducer,
    alerts: alertReducer,
    modal:modalReducer,
    resourceSearchResult: resourceSearchReducer,
    etextStatuses: etextStatusReducer,
    productDetails: productDetailsReducer,
    offerDetails:offerDetailsReducer,
    vitalsourceStatuses: vitalsourceStatusReducer,
    resourceUploadData:uploadReducer,
    opsAdminCompCode: compCodeReducer,
    registrarCourseSectionDetails:courseDetailsReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/_reducers/index.js